<template>
  <div>
    <Header />
    <section class="login-page section-b-space mt90">
      <div class="container">
        <form class="theme-form" v-on:submit="checkForm" method="post">
          <div v-if="errors.length">
            <ul class="validation-error mb-3">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div v-if="globalError">
            <ul class="validation-error mb-3">
              <li>{{ globalError }}</li>
            </ul>
          </div>
          <div class="w-90">
            <h2 class="text-center register-title">{{'Reset Password'}}</h2>
            <h4>{{resetUsername}}</h4>
            <div class="form-group">
              <label for="user" class="border-label"><i class="fa fa-user"></i></label>
              <input
                  type="text"
                  class="bottom-input"
                  id="user"
                  v-model="user"
                  placeholder="Email is your user name"
                  name="user"
                  required
              />
            </div>
            <div class="form-group d-flex justify-content-center mt-5">
              <input type="submit" class="btn btn-register" value="Get verification code" />
            </div>
          </div>
        </form>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>

import Header from "../components/header";
import Footer from "../components/footer";


import { forgotPassword } from "@/utils/auth.js";

import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
    })
  },
  data() {
    return {
      logintitle: "Login",
      errors: [],
      user: null,
    };
  },
  props: {

  },
  mounted() {
    this.$store.dispatch("setGlobalError",{value:""});
  },
  methods: {
    checkForm: async function(e) {
      this.errors = [];
      if (!this.user) {
        this.errors.push("User name (your email) is required.");
      }
      e.preventDefault();
      if (!this.errors.length) {

        this.$store.dispatch('auth/setSigninLog',{type: 'password_start', 'signinusername':this.user.toLowerCase()});
        this.$store.dispatch('auth/setResetUsername', {reset_username: this.user})
        forgotPassword(this.user, this.$store);
      }
    }
  }
};
</script>
